import * as React from "react";
import { Tab } from "./tab";
import { utilRaiseError } from "./util/util";
import { FlexContainer } from "../grid/flexcontainer";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const isReactTabChild = (value) => typeof value === "object";
const barClass = css({
    display: "flex",
    borderBottom: `1px solid ${getThemeColorVar("border", "default")}`,
});
const containerClass = css({
    height: "100%",
});
const barWrapperClass = css({
    overflowX: "auto",
    flex: "0 0 auto",
});
const contentClass = css({
    display: "grid",
    height: "100%",
    border: `1px solid ${getThemeColorVar("border", "default")}`,
    borderTop: "0px transparent",
});
const headerItemClass = css({
    backgroundColor: getThemeColorVar("background", "light"),
    borderTop: `1px solid ${getThemeColorVar("border", "default")}`,
    borderLeft: `1px solid ${getThemeColorVar("border", "default")}`,
    color: getThemeColorVar("typo", "default"),
    cursor: "pointer",
    padding: "12px 15px",
    whiteWpace: "nowrap",
    "&:last-child": {
        borderRight: `1px solid ${getThemeColorVar("border", "default")}`,
    },
});
const headerItemActiveClass = css({
    backgroundColor: "#ffffff",
    borderTop: `3px solid ${getThemeColorVar("primary", "default")}`,
    borderBottom: "1px solid #ffffff",
    color: getThemeColorVar("primary", "default"),
    cursor: "initial",
    fontWeight: "bold",
    padding: "10px 15px",
    marginBottom: "-1px",
    zIndex: 1,
});
const paneClass = css({
    display: "none",
    height: "100%",
});
const paneActiveClass = css({
    display: "block",
});
export class ReTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSelectedIndex: typeof props.selectedIndex === "number" ? props.selectedIndex : null,
        };
    }
    onClick(idx, tab) {
        return (event) => {
            if ((typeof this.props.selectedIndex === "number" &&
                idx !== this.props.selectedIndex) ||
                idx !== this.state.currentSelectedIndex) {
                this.setState({ currentSelectedIndex: idx });
                if (tab.props.onActive)
                    tab.props.onActive();
                this.props.onChange &&
                    this.props.onChange(idx, tab.props.value, tab, event);
            }
        };
    }
    render() {
        const tabsContent = React.Children.map(this.props.children, (element) => element);
        const tabs = tabsContent
            ? tabsContent.filter(isReactTabChild)
            : [];
        const activeTabs = tabs.filter((el) => el.props.active === true);
        const initialTabEl = activeTabs.length > 0 ? activeTabs[0] : tabs[0];
        const tabElements = [];
        const panelElements = [];
        for (let idx = 0; idx < tabs.length; idx++) {
            const item = tabs[idx];
            if (typeof item === "object" && item.type === Tab) {
                const isActive = this.state.currentSelectedIndex === null
                    ? item === initialTabEl
                    : this.state.currentSelectedIndex === idx;
                const headerClasses = [headerItemClass];
                isActive && headerClasses.push(headerItemActiveClass);
                tabElements.push(React.createElement("div", { key: idx, className: cx(headerClasses), onClick: this.onClick(idx, item) }, item.props.label));
                const paneClasses = [paneClass];
                isActive && paneClasses.push(paneActiveClass);
                panelElements.push(React.createElement("div", { key: idx, className: cx(paneClasses) }, item.props.children));
            }
            else {
                utilRaiseError("Expected Tabs only containing Tab elements");
            }
        }
        return (React.createElement("div", { className: cx(containerClass) },
            React.createElement(FlexContainer, { direction: "col", canShrink: false },
                React.createElement("div", { className: cx(barWrapperClass) },
                    React.createElement("div", { className: cx(barClass) }, tabElements)),
                React.createElement("div", { className: cx(contentClass) }, panelElements))));
    }
}
export default ReTabs;
//# sourceMappingURL=retabs.js.map